export default __webpack_public_path__ + "static/lut-virusi-d-r-atanasova-d8dd2899eca4e326d44873b8bb9c86ce.jpg";